import axios from 'axios';
export const createPage = async (pagesApiRoot, token, input) => axios
    .post(`${pagesApiRoot}/`, input, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const updatePage = async (pagesApiRoot, token, input) => axios
    .put(`${pagesApiRoot}/`, input, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const deletePage = async (pagesApiRoot, token, input) => axios
    .delete(`${pagesApiRoot}/${input.id}`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const getPageById = async (pagesApiRoot, input) => axios
    .get(`${pagesApiRoot}/${input.id}`) //
    .then((output) => output.data)
    .catch(async (err) => (err.response?.status === 404 ? undefined : Promise.reject(err)));
export const getPageDetailsById = async (pagesApiRoot, token, input) => axios
    .get(`${pagesApiRoot}/${input.id}/details`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data)
    .catch(async (err) => (err.response?.status === 404 ? undefined : Promise.reject(err)));
export const listPages = async (pagesApiRoot, token, input) => axios
    .get(`${pagesApiRoot}`, {
    params: {
        wallet: input.wallet,
    },
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const uploadAsset = async (pagesApiRoot, token, input) => axios
    .post(`${pagesApiRoot}/asset/${input.wallet}`, {}, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const toggleLeadFeature = async (pagesApiRoot, token, input) => axios
    .put(`${pagesApiRoot}/${input.wallet}/feature/lead`, input, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const isLeadFeatureEnabled = async (pagesApiRoot, token, wallet) => axios
    .get(`${pagesApiRoot}/${wallet}/feature/lead`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const applyGateway = (wallet, id, gatewayUrl) => `${gatewayUrl}/${wallet}/${id}`;
export const submitPageLeadForm = async (pagesApiRoot, input) => axios.post(`${pagesApiRoot}/leads`, input).then((output) => output.data);
export const listPagesLeads = async (pagesApiRoot, token, input) => axios
    .get(`${pagesApiRoot}/leads?wallet=${input.wallet}&page=${input.page}&from=${input.range.from}&to=${input.range.to}`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
//# sourceMappingURL=index.js.map